module.exports = __webpack_public_path__ + "static/media/Bluelab Truncheon Nutrient Meter.c4776bb8.webp";